import { useUnreadMessagesTracker } from "../../hooks/useUnreadMessagesTracker";
import React, { useCallback, useMemo } from "react";
import { ControlBarChatButton } from "./ControlBarChatButton";
import { IButtonStyles, Stack } from "@fluentui/react";
import { NotificationIcon } from "../NotificationIcon";
import { ControlBarButtonProps, useChatClient } from "@azure/communication-react";
import { usePcpChatThreadState } from "../../store/slices/chatThreadStateSlice";
import { Chat24Filled } from "@fluentui/react-icons";

interface ChatButtonWithUnreadMessageCountProps extends ControlBarButtonProps{
    onClick: () => void;
    checked: boolean;
    showLabel?: boolean;
    hideUnreadChatMessagesBadge?: boolean;
}

const filledIcon = <Chat24Filled />;

// regular icon is unused - keeping for doc for now
// const regularIcon = <FontIcon iconName={'ControlBarChatButtonInactive'} />;

export const ChatButtonWithUnreadMessageCount = (props: ChatButtonWithUnreadMessageCountProps) => {
    const {
        checked,
        onClick,
        hideUnreadChatMessagesBadge = false,
    } = props;

    const chatClient = useChatClient();

    const pcpChatThreadState = usePcpChatThreadState();
    const unreadMessagesCount = useUnreadMessagesTracker(chatClient, props.checked, true, pcpChatThreadState.groupChat);
    const buttonStyles = useMemo(() => ({
            ...props.styles,
            flexContainer: {
                position: 'static !important' as 'static'  //fixes 'NotificationIcon' position when button pressed
            }
        }) as IButtonStyles,
        [props.styles]
    );

    const onRenderOnIcon = useCallback(() => filledIcon, []);
    const notificationOffIcon = useCallback((): JSX.Element => (
            <Stack>
                {unreadMessagesCount > 0 && !hideUnreadChatMessagesBadge && (
                    <NotificationIcon chatMessagesCount={unreadMessagesCount} label={'Chat'} />
                )}
                {filledIcon}
            </Stack>
        ), [unreadMessagesCount, hideUnreadChatMessagesBadge]);

    return (
        <ControlBarChatButton
            {...props}
            name="chat"
            onClick={onClick}
            checked={checked}
            onRenderOffIcon={notificationOffIcon}
            onRenderOnIcon={onRenderOnIcon}
            styles={buttonStyles}
        />
    );
};
